import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { ScorecardFragmentDoc } from '../../../../../../scorecards/graphql/fragments/generated/Scorecard';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ScorecardsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.ScorecardsFilters>;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ScorecardsQuery = { scorecards: { success: boolean, totalCount: number, errorCode?: Types.PaginationErrorCodeEnum | null, edges?: Array<{ node: { id: string, title: string, skill?: { name: string, id: string } | null, questions?: Array<{ id: string, text: string, order: number, maxScore: number }> | null } }> | null, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null } };


export const ScorecardsDocument = /*#__PURE__*/ gql`
    query scorecards($filters: ScorecardsFilters, $sort: [SortType!], $first: Float, $after: String) {
  scorecards(filters: $filters, sort: $sort, first: $first, after: $after) {
    edges {
      node {
        ...Scorecard
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    success
    totalCount
    errorCode
  }
}
    ${ScorecardFragmentDoc}`;

export function useScorecardsQuery(options?: Omit<Urql.UseQueryArgs<ScorecardsQueryVariables>, 'query'>) {
  return Urql.useQuery<ScorecardsQuery, ScorecardsQueryVariables>({ query: ScorecardsDocument, ...options });
};